module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av641-9fdbb628a479921f7e3a0fc87eff59f3.jpg";